<template>
  <div class="shortcut">
    <div class="block">
      <div class="left">
        <div v-if="!isLogin">
          <!-- <span>你好，请登录</span> -->
          <span>{{ $t("你好，请登录") }}</span>
          <router-link tag="span" :to="{ path: '/login/login' }" class="r">{{
            $t("免费注册")
          }}</router-link>
        </div>
        <div v-else>
          <span class="r">{{ $t("你好") }},{{ nickname }}</span>
          <span @click="dialogVisible = true">{{ $t("退出") }}</span>
        </div>
      </div>
      <div class="right">
        <div class="list">
          <div class="item" v-if="isLogin">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ $t("个人中心")
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/personal/order">{{
                  $t("我的订单")
                }}</el-dropdown-item>
                <el-dropdown-item command="/personal/coupon">{{
                  $t("优惠券")
                }}</el-dropdown-item>
                <el-dropdown-item command="/personal/myFp">{{
                  $t("我的发票")
                }}</el-dropdown-item>
                <el-dropdown-item disabled command="a">{{
                  $t("BOM需求")
                }}</el-dropdown-item>
                <el-dropdown-item divided command="/personal/index">{{
                  $t("账号管理")
                }}</el-dropdown-item>
                <el-dropdown-item command="/personal/addAddress">{{
                  $t("我的收货地址")
                }}</el-dropdown-item>
                <el-dropdown-item divided command="/personal/integral">{{
                  $t("我的积分")
                }}</el-dropdown-item>
                <el-dropdown-item command="/personal/footprint">{{
                  $t("我的足迹")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="item">
            <span>消息({{nickname}})</span>
          </div> -->
          <!-- <div class="item">
            <span>PCB/SMT/钢网下单</span>
          </div> -->
          <!-- <div class="item">
            <span>3D打印</span>
          </div> -->
          <!-- <div class="item">
            <span>中信华PCB</span>
          </div> -->
          <!-- <div class="item">
            <span>面板打印</span>
          </div> -->
          <div class="item" @click="getQQ">
            <img
              src="../../assets/img/QQ.png"
              :alt="$t('QQ咨询')"
              class="img"
            />
            <span>{{ contact.web_qq }}</span>
          </div>
          <div class="item">
            <img
              src="../../assets/img/phone.png"
              :alt="$t('客服')"
              class="img"
            />
            <span>{{ contact.web_tel }}</span>
          </div>
          <!-- <div class="item">
            <span>{{common.config.web_tel}}</span>
          </div> -->
          <div class="item" @click="$jx.addFavorite()">
            <img
              src="../../assets/img/shoucang.png"
              :alt="$t('客服')"
              class="img"
            />
            <span>{{ $t("收藏网址") }}</span>
          </div>
          <div class="item" @click="getShanghu()">
            <span style="padding-left:10px">{{ $t("商户后台") }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$t('退出提示')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $t("是否确认退出") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("取 消") }}</el-button>
        <el-button type="primary" @click="Out">{{ $t("确 定") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isLogin: false,
      dialogVisible: false,
      nickname: "",
      contact: {}
    };
  },
  computed: {
    ...mapState(["common"])
  },
  mounted() {
    this.getSelf();
  },
  methods: {
    getShanghu() {
      window.open(`http://admin.cismarket.cn`);
    },
    getQQ() {
      let common = JSON.parse(localStorage.getItem("jx:common")).data;
      window.open(
        `http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`
      );
    },
    // 退出
    Out() {
      this.$http.post("/wanlshop/user/logout", {}).then(
        res => {
          if (res.code == 1) {
            this.$router.push({ name: "main" });
            localStorage.clear();
            location.reload();
            // main
          }
          this.$jx.open1(res.msg);
          this.dialogVisible = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    // 个人中心跳转
    handleCommand(command) {
      this.$router.push({
        path: command
      });
    },
    getSelf() {
      setTimeout(() => {
        this.contact = JSON.parse(localStorage.getItem("jx:common")).data;
      }, 1000);
      if (localStorage.getItem("token")) {
        this.$http.post("/wanlshop/user/refresh", {}).then(
          res => {
            let userinfo = JSON.stringify(res.data.userinfo);
            localStorage.setItem("userinfo", userinfo);
            this.nickname = res.data.userinfo.nickname;
          },
          err => {
            console.log(err);
          }
        );
        this.isLogin = true;
      }
    }
  }
};
</script>
<style lang="scss">
.shortcut {
  background-color: #e3e4e5;
  border-bottom: 1px solid #dddddd;
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;

  .block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    background-color: #e3e4e5;

    .left {
      color: #969696;
      font-size: 12px;
      cursor: pointer;

      .r {
        color: #3d7fff;
      }
    }

    .right {
      font-size: 12px;

      .list {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .item {
          color: #969696;
          display: flex;
          align-items: center;
          .img {
            width: 16px;
            height: 16px;
            margin: 0 6px 0 10px;
          }
          span {
            padding-right: 10px;
            border-right: 1px solid #cccccc;
            cursor: pointer;
          }

          &:last-child {
            span {
              border: none;
            }
          }
        }
      }
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #969696;
  font-size: 12px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/shortcut/shortcut.vue